import './index.erb';
import './index.rb';
import './index.scss';

const OAB_DAMASIO_BANNER_EVENT = 'oab damasio banner';
const OAB_BANNER_EXCEPT = ['user', 'iterable', 'appcues'];

class OabQuestionsBanner {
  constructor() {
    this.banner = $('.banner-oab-questions');
    this.link = this.banner.find('a[data-track-click]');
  }

  init() {
    this.trackImpression();
    this.trackClick();
  }

  trackImpression() {
    if (this.banner.length) {
      this.dispatchTrackerEvent('impression', {
        utm_source: 'qconcursos',
        utm_medium: 'banner',
        utm_campaign: 'oab-damasio-questions'
      });
    }
  }

  trackClick() {
    this.link.on('click', e => {
      const link = $(e.currentTarget);

      this.dispatchTrackerEvent('click', {
        utm_source: 'qconcursos',
        utm_medium: 'banner',
        utm_campaign: 'oab-damasio-questions',
        'destination url': link.attr('href')
      });
    });
  }

  dispatchTrackerEvent(event, params = {}) {
    const data = {
      eventName: `${OAB_DAMASIO_BANNER_EVENT} ${event}`,
      except: OAB_BANNER_EXCEPT,
      data: { ...params }
    };

    try {
      UserTracker.emit('event', data);
    } catch (error) {
      Rollbar.error('OabQuestionsBanner dispatchTrackerEvent', error);
    }
  }
}

(() => {
  new OabQuestionsBanner().init();
})();
